export interface Recommendation {
  id: string;
  dosha: "vata" | "pitta" | "kapha";
  category: "alimentacao" | "rotina" | "mental" | "estilo_vida";
  title: string;
  content: string;
}

export interface Video {
  id: string;
  title: string;
  description: string;
  youtubeUrl: string;
  dosha: "vata" | "pitta" | "kapha";
  category: "alimentacao" | "rotina" | "mental" | "estilo_vida";
}

export const recommendations: Recommendation[] = [
  // VATA
  {
    id: "v1",
    dosha: "vata",
    category: "alimentacao",
    title: "Alimentação para equilibrar Vata",
    content: "Prefira alimentos quentes, úmidos e nutritivos. Sopa de legumes, arroz integral, abóbora, batata-doce e ghee são excelentes. Evite alimentos crus, secos ou muito frios. Coma em horários regulares e nunca pule refeições.",
  },
  {
    id: "v2",
    dosha: "vata",
    category: "rotina",
    title: "Rotina diária para Vata",
    content: "Acorde e durma sempre no mesmo horário. Pratique yoga suave, meditação e caminhadas ao ar livre. Mantenha uma rotina estruturada — Vata se beneficia enormemente da regularidade. Evite excesso de estímulos e multitarefas.",
  },
  {
    id: "v3",
    dosha: "vata",
    category: "mental",
    title: "Equilíbrio mental para Vata",
    content: "A ansiedade e a inquietação são sinais de Vata elevado. Pratique respiração profunda (pranayama), meditação guiada e journaling. Mantenha contato com amigos e evite isolamento. Música suave e aromas como lavanda e sândalo ajudam a acalmar.",
  },
  {
    id: "v4",
    dosha: "vata",
    category: "estilo_vida",
    title: "Estilo de vida para Vata",
    content: "Mantenha o corpo aquecido — use roupas adequadas e evite correntes de ar. Faça massagens com óleo quente (abhyanga) regularmente. Durma cedo, antes das 22h. Evite viagens excessivas e mudanças bruscas de rotina.",
  },
  // PITTA
  {
    id: "p1",
    dosha: "pitta",
    category: "alimentacao",
    title: "Alimentação refrescante para Pitta",
    content: "Prefira alimentos frescos, doces e amargos. Pepino, melão, coco, menta, brócolis e espinafre são ideais. Evite comidas picantes, frituras, café e álcool. Coma em ambiente calmo e sem pressa.",
  },
  {
    id: "p2",
    dosha: "pitta",
    category: "rotina",
    title: "Rotina para reduzir o excesso de fogo",
    content: "Evite atividades intensas no horário do meio-dia (10h-14h). Pratique yoga relaxante, natação ou caminhadas em ambientes frescos. Reserve momentos de descanso e lazer. Não se sobrecarregue com metas excessivas.",
  },
  {
    id: "p3",
    dosha: "pitta",
    category: "mental",
    title: "Controle mental para Pitta",
    content: "A raiva e a irritação são sinais de Pitta elevado. Pratique a gratidão diária, perdão e compaixão. Evite debates acalorados e situações de competitividade excessiva. Aromas como rosa, jasmim e camomila são calmantes.",
  },
  {
    id: "p4",
    dosha: "pitta",
    category: "estilo_vida",
    title: "Estilo de vida para Pitta",
    content: "Prefira ambientes frescos e arejados. Use cores suaves e azuis. Evite exposição excessiva ao sol. Faça atividades criativas e relaxantes. Mantenha um equilíbrio entre trabalho e lazer. Evite perfectionismo.",
  },
  // KAPHA
  {
    id: "k1",
    dosha: "kapha",
    category: "alimentacao",
    title: "Alimentação estimulante para Kapha",
    content: "Prefira alimentos leves, quentes e picantes. Gengibre, pimenta, mel, chá verde, legumes variados e cereais integrais. Evite laticínios, doces, massas e alimentos pesados. Diminua a quantidade de refeições se necessário.",
  },
  {
    id: "k2",
    dosha: "kapha",
    category: "rotina",
    title: "Rotina ativadora para Kapha",
    content: "Acorde cedo, antes das 6h. Pratique exercícios vigorosos como corrida, musculação ou dança. Evite dormir durante o dia. Mantenha-se ativo e movimentado. Varie a rotina para evitar monotonia.",
  },
  {
    id: "k3",
    dosha: "kapha",
    category: "mental",
    title: "Energia mental para Kapha",
    content: "A preguiça e a acomodação são sinais de Kapha elevado. Estabeleça metas claras e desafiadoras. Pratique novos hobbies e aprenda coisas novas. Socialize-se e evite isolamento. Aromas como eucalipto e alecrim são estimulantes.",
  },
  {
    id: "k4",
    dosha: "kapha",
    category: "estilo_vida",
    title: "Estilo de vida dinâmico para Kapha",
    content: "Mantenha-se em ambientes arejados e iluminados. Use cores vibrantes e quentes. Evite umidade excessiva. Faça limpezas e desapegos regularmente. Viaje e explore novos lugares. Mantenha a mente e o corpo sempre em movimento.",
  },
];

export const videos: Video[] = [
  {
    id: "vv1",
    title: "Yoga Nidra para Acalmar a Ansiedade Vata",
    description: "Meditação guiada de 24 minutos com Ally Boothroyd — grounding profundo para aquietar a mente acelerada e ansiosa.",
    youtubeUrl: "https://www.youtube.com/embed/Dhu1naJc2Q8",
    dosha: "vata",
    category: "mental",
  },
  {
    id: "vv2",
    title: "Rotina Matinal Ayurvédica Completa (Dinacharya)",
    description: "9 práticas diárias essenciais: tongue scraping, oil pulling, dry brushing, abhyanga e mais — com Yoga International.",
    youtubeUrl: "https://www.youtube.com/embed/WOYGEjTs2Bw",
    dosha: "vata",
    category: "rotina",
  },
  {
    id: "vv3",
    title: "Guia de Alimentação para Vata — O que Comer e Evitar",
    description: "Banyan Botanicals explica os alimentos que aterram e nutrem Vata: quentes, úmidos, cozidos e oleosos.",
    youtubeUrl: "https://www.youtube.com/embed/in7MUkLJgPY",
    dosha: "vata",
    category: "alimentacao",
  },
  {
    id: "vv4",
    title: "Yoga Nidra para Sono Profundo — Grounding Vata",
    description: "30 minutos de relaxamento guiado por Ally Boothroyd para combater insônia e acalmar o sistema nervoso antes de dormir.",
    youtubeUrl: "https://www.youtube.com/embed/kiuAqWbU7FA",
    dosha: "vata",
    category: "estilo_vida",
  },
  {
    id: "vp1",
    title: "Sheetali Pranayama — Respiração Refrescante para Controlar a Raiva",
    description: "Técnica de respiração ayurvédica que resfria o corpo e acalma a mente Pitta em minutos. Com Yoga With Adriene.",
    youtubeUrl: "https://www.youtube.com/embed/67SeMMFteBQ",
    dosha: "pitta",
    category: "mental",
  },
  {
    id: "vp2",
    title: "Alimentação Refrescante para Pitta — Guia Completo",
    description: "The Yoga Institute explica a dieta ideal para equilibrar o fogo interno: alimentos doces, amargos e adstringentes.",
    youtubeUrl: "https://www.youtube.com/embed/k-YTKMKpN2Y",
    dosha: "pitta",
    category: "alimentacao",
  },
  {
    id: "vp3",
    title: "Mindfulness para Equilibrar Pitta — Meditação Guiada",
    description: "Prática de atenção plena focada em resfriar a mente competitiva e acalmar os impulsos do perfeccionismo.",
    youtubeUrl: "https://www.youtube.com/embed/ssJ7wT6jmzI",
    dosha: "pitta",
    category: "mental",
  },
  {
    id: "vp4",
    title: "Cooling Pitta Yoga Flow — Paz Interior para o Fogo Interno",
    description: "Kama Ayurveda guia um fluxo refrescante de yoga com twists e posturas de entrega para acalmar o temperamento Pitta.",
    youtubeUrl: "https://www.youtube.com/embed/9oJ9n0JM0Q",
    dosha: "pitta",
    category: "rotina",
  },
  {
    id: "vk1",
    title: "Como Aumentar a Energia Diária — Fim da Letargia Kapha",
    description: "Satvic Movement revela os alimentos que drenam energia e ensina um plano de 7 passos para recuperar a vitalidade.",
    youtubeUrl: "https://www.youtube.com/embed/Epl1cKZ6cBs",
    dosha: "kapha",
    category: "estilo_vida",
  },
  {
    id: "vk2",
    title: "Produtividade Ayurvédica — Vença a Procrastinação Kapha",
    description: "Rotina e hábitos baseados no Ayurveda para sair da estagnação e criar momentum diário com energia consistente.",
    youtubeUrl: "https://www.youtube.com/embed/WOYGEjTs2Bw",
    dosha: "kapha",
    category: "rotina",
  },
  {
    id: "vk3",
    title: "Alimentação Estimulante para Kapha — Metabolismo Acelerado",
    description: "Guia de especiarias e alimentos quentes que ativam o fogo digestivo lento de Kapha: gengibre, pimenta e muito mais.",
    youtubeUrl: "https://www.youtube.com/embed/pG0rkj6hEKI",
    dosha: "kapha",
    category: "alimentacao",
  },
  {
    id: "vk4",
    title: "Kapha Yoga Flow — 15 Minutos para Energizar o Corpo",
    description: "Vinyasa para iniciantes com Clareminded — fluxo matinal que aquece, estimula a circulação e desperta o corpo pesado.",
    youtubeUrl: "https://www.youtube.com/embed/fDRnH3erao4",
    dosha: "kapha",
    category: "rotina",
  },
];